import React from 'react';
import styled from 'libs/styled';
import CookietractorInformationBlock from 'libs/sanity/content/Blocks/CookietractorInformationBlock';

const ModuleWrapper = styled('div')`
    margin: var(--module-margin-y) 0;
`;

const CookietractorInformationModule = () => (
    <ModuleWrapper>
        <CookietractorInformationBlock />
    </ModuleWrapper>
);

export default CookietractorInformationModule;
